module.exports = __webpack_public_path__ + "img/ai-magic.7205c51c.svg";